import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";
import { Badge } from "@toddle-edu/ds-web";
import {
  ArchiveOutlined,
  BellCancelledOutlined,
  PencilOutlined,
} from "@toddle-edu/ds-icons";

import { getMessagingV2ReduxState } from "MessagingV2/modules/MessagingModule";
import classes from "./ThreadAction.scss";
import { isMessagingRevempEnabled } from "MessagingV2/modules/Utils";

const DraftIcon = ({ hasDraftMessage }) =>
  hasDraftMessage ? <PencilOutlined size="xxx-small" /> : null;

const mapStateToProps = (state, ownProps) => {
  const { threadId } = ownProps;
  const messagingReduxState = getMessagingV2ReduxState(state);
  const draftMessage = _.get(messagingReduxState, ["drafts", threadId]);
  const hasDraftMessage = !_.isEmpty(draftMessage);

  return { hasDraftMessage };
};

const DraftIconWrapper = connect(mapStateToProps)(DraftIcon);

const ThreadAction = props => {
  const {
    unreadMessageCount,
    timeSinceLastMessage,
    isChatMuted = false,
    isArchived,
    id: threadId,
    selected = false,
  } = props;

  const isUIRevempEnabled = isMessagingRevempEnabled();

  const timeClasses = classNames("text-tooltip", classes.timeContainer);
  const timeClassesV2 = classNames("text-body-3", classes.timeContainerV2);

  if (!unreadMessageCount && !timeSinceLastMessage && !isChatMuted) {
    return null;
  }

  return (
    <div
      className={
        isUIRevempEnabled
          ? classes.threadActionContainerV2
          : classes.threadActionContainer
      }
    >
      <div className={isUIRevempEnabled ? timeClassesV2 : timeClasses}>
        {timeSinceLastMessage}
      </div>
      <div
        className={
          isUIRevempEnabled ? classes.threadActionsV2 : classes.threadActions
        }
      >
        {isChatMuted ? (
          <BellCancelledOutlined
            className={classes.bell}
            size="xxx-small"
            variant={isUIRevempEnabled ? "subtle" : "default"}
          />
        ) : null}
        {!selected ? <DraftIconWrapper threadId={threadId} /> : null}
        {unreadMessageCount ? (
          <div>
            {isUIRevempEnabled ? (
              <span
                className={classNames("text-label-4", classes.customBadgeCount)}
              >
                {unreadMessageCount}
              </span>
            ) : (
              <Badge type="numeric" value={unreadMessageCount} />
            )}
          </div>
        ) : null}
        {isArchived ? (
          <ArchiveOutlined variant={isUIRevempEnabled ? "subtle" : "default"} />
        ) : null}
      </div>
    </div>
  );
};

ThreadAction.propTypes = {
  unreadMessageCount: PropTypes.number,
  timeSinceLastMessage: PropTypes.string,
  isChatMuted: PropTypes.bool,
  isRemovable: PropTypes.bool,
};

export default ThreadAction;
